import React from 'react'
import { View, Platform } from 'react-native'
import PropTypes from 'prop-types'

import Identity from '../../utils/Identity'
import LocationsInformation from './LocationsInformation'
import useStyles from './useStyles'
import { useTheme } from '../../theming/ThemeProvider'
import { usePlatforms } from '../../hooks/usePlatforms'
import { getCardsLocationText } from '../../tools/dataParse'
import Txt from '../Txt'
import Menu from '../Menu'
import Icon from '../Icons'
import { getLaneColor } from '../../tools/objectMapValues'

const LaneCard = ({ lane, editLane, deleteLane, index, invalid }) => {
  const { isTablet, isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const styles = useStyles(theme, isDesktop)

  const { origin, destination, equipmentType } = lane

  const onEditLane = () => editLane(lane)
  const onDeleteLane = () => deleteLane(lane)

  const menuItems = [
    {
      text: 'Edit',
      fn: onEditLane
    },
    {
      text: 'Delete',
      fn: onDeleteLane
    }
  ]

  return (
    <View
      style={[
        styles.cardStyle,
        Identity.Shadow(theme).Card,
        isTablet && Platform.OS === 'web' && {
          borderLeftWidth: 5,
          borderLeftColor: getLaneColor(index)
        }
      ]}
      testID={`laneCard${index}`}
      accessibilityLabel={`laneCard${index}`}
    >
      <View style={{ flex: 1 }}>
        <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap' }}>
          <View style={[styles.location, isTablet && { flex: isDesktop ? 4 : 3 }]}>
            <LocationsInformation
              origin={getCardsLocationText(origin)}
              destination={getCardsLocationText(destination)}
            />
          </View>
          <View style={styles.information}>
            <View
              style={{
                marginLeft: isDesktop ? 20 : 0,
                marginBottom: isDesktop ? 0 : 5,
                flexDirection: isDesktop ? 'row' : 'column',
                alignItems: 'flex-end',
                width: 'auto',
                justifyContent: isDesktop ? 'flex-start' : 'space-between'
              }}
            >
              {isDesktop && (
                <Icon
                  fill={theme.BUNKER}
                  name='Tractors'
                  height={24}
                  width={24}
                />
              )}
              <Txt
                color={isDesktop ? 'OUTER_SPACE' : 'SLATE_GRAY'}
                text={equipmentType ? equipmentType.description : '- -'}
                identity='body2'
                style={[styles.Text, isDesktop ? { width: 'auto' } : { marginTop: 5 }]}
              />
              {/* <Txt
                color='GOLDEN_GRASS'
                text={`${stopsCount || 0} stops`}
                style={[styles.Text, !isTablet && { marginBottom: 10 }]}
              />
              <Txt
                color='OUTER_SPACE'
                text={`${maxWeight || '- -'} lbs`}
                identity='body2Bold'
                style={styles.Text}
              /> */}
            </View>
          </View>
        </View>
        {invalid && (
          <View style={{ marginTop: 10 }}>
            <View style={{ padding: 5, backgroundColor: theme.GOLDEN_GRASS, borderRadius: 4, width: 150 }}>
              <Txt
                color='WHITE_TEXT'
                text="This route can't be drawn"
                identity='body3'
              />
            </View>
          </View>
        )}
      </View>
      <View testID={`laneCardMenu${index}`} accessibilityLabel={`laneCardMenu${index}`}>
        <Menu
          items={menuItems} style={{
            width: isDesktop ? 30 : 25,
            height: isDesktop ? 30 : 25,
            borderRadius: 100,
            backgroundColor: theme.GALLERY,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 15
          }}
        >
          <Icon
            fill={theme.SLATE_GRAY_TEXT}
            name='ShowMore'
            height={isDesktop ? 20 : 18}
            width={isDesktop ? 20 : 18}
          />
        </Menu>
      </View>

    </View>
  )
}

LaneCard.propTypes = {
  lane: PropTypes.object,
  editLane: PropTypes.func,
  deleteLane: PropTypes.func,
  index: PropTypes.number,
  invalid: PropTypes.bool
}

export default LaneCard
